// Mock data for TheEqualizer.AI Assistant

export const mockLegalIssues = [
  {
    id: 1,
    title: 'Landlord-Tenant Disputes',
    description: 'Handle rental agreements, security deposits, evictions, and property maintenance issues.',
    icon: 'home',
    cases: 142,
    successRate: '94%'
  },
  {
    id: 2,
    title: 'Small Claims Court',
    description: 'Recover money owed, resolve consumer disputes, and handle property damage claims.',
    icon: 'scale',
    cases: 128,
    successRate: '89%'
  },
  {
    id: 3,
    title: 'Employment Issues',
    description: 'Address workplace discrimination, wage disputes, and wrongful termination.',
    icon: 'briefcase',
    cases: 115,
    successRate: '92%'
  },
  {
    id: 4,
    title: 'Contract Disputes',
    description: 'Resolve breaches of contract, negotiation disputes, and agreement violations.',
    icon: 'file-text',
    cases: 97,
    successRate: '87%'
  },
  {
    id: 5,
    title: 'Consumer Protection',
    description: 'Fight unfair business practices, warranty issues, and fraudulent charges.',
    icon: 'shield',
    cases: 83,
    successRate: '91%'
  },
  {
    id: 6,
    title: 'Traffic Violations',
    description: 'Contest tickets, license issues, and minor traffic court matters.',
    icon: 'car',
    cases: 134,
    successRate: '85%'
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: 'Sarah Martinez',
    role: 'Small Business Owner',
    image: 'https://customer-assets.emergentagent.com/job_legal-petition/artifacts/pnblncki_Screenshot%202025-09-09%20at%203.38.24%E2%80%AFPM.png',
    content: 'TheEqualizer.AI helped me draft a cease and desist letter that resolved my trademark dispute quickly. The AI analysis was spot-on, and I saved thousands in legal fees.',
    rating: 5,
    case: 'Intellectual Property'
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Apartment Renter',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
    content: 'When my landlord refused to return my security deposit, TheEqualizer.AI provided me with the exact steps and templates I needed. Got my full deposit back within two weeks.',
    rating: 5,
    case: 'Landlord-Tenant'
  },
  {
    id: 3,
    name: 'Jennifer Williams',
    role: 'Freelance Designer',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    content: 'A client wasn\'t paying for completed work. The AI assistant guided me through small claims court preparation. I recovered the full amount plus court costs.',
    rating: 5,
    case: 'Contract Dispute'
  },
  {
    id: 4,
    name: 'David Rodriguez',
    role: 'Restaurant Manager',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop&crop=face',
    content: 'Dealing with an unfair employment termination was overwhelming. TheEqualizer.AI broke down my options clearly and helped me negotiate a fair settlement.',
    rating: 5,
    case: 'Employment'
  }
];

export const mockFAQs = [
  {
    id: 1,
    question: 'Is TheEqualizer.AI a replacement for a lawyer?',
    answer: 'No, TheEqualizer.AI is an AI assistant that provides guidance, templates, and step-by-step instructions. For complex matters or court representation, we recommend consulting with a qualified attorney.'
  },
  {
    id: 2,
    question: 'How accurate is the AI analysis?',
    answer: 'Our AI is trained on extensive legal databases and case law. While highly accurate for common legal issues, it should be used as a starting point for legal research and guidance, not as definitive legal advice.'
  },
  {
    id: 3,
    question: 'What types of documents can TheEqualizer.AI help create?',
    answer: 'We can help generate cease and desist letters, demand letters, small claims court documents, lease agreements, employment contracts, and many other common templates.'
  },
  {
    id: 4,
    question: 'Is my information kept confidential?',
    answer: 'Yes, we take privacy seriously. All information shared with TheEqualizer.AI is encrypted and confidential. We do not share your data with third parties or use it for marketing purposes.'
  },
  {
    id: 5,
    question: 'How much does TheEqualizer.AI cost?',
    answer: 'We offer both free and premium tiers. Basic legal guidance is free, while premium features like advanced document generation and priority support require a subscription.'
  },
  {
    id: 6,
    question: 'Can TheEqualizer.AI help with court representation?',
    answer: 'TheEqualizer.AI can help you prepare for court by providing relevant case law, document templates, and procedural guidance. However, it cannot represent you in court - only licensed attorneys can do that.'
  }
];

export const mockLegalResources = [
  {
    id: 1,
    title: 'Understanding Your Rights as a Tenant',
    type: 'Guide',
    readTime: '8 min read',
    category: 'Landlord-Tenant',
    summary: 'Learn about tenant rights, security deposits, and how to handle common landlord disputes.'
  },
  {
    id: 2,
    title: 'Small Claims Court: A Complete Guide',
    type: 'Guide',
    readTime: '12 min read',
    category: 'Small Claims',
    summary: 'Step-by-step process for filing in small claims court, including forms and procedures.'
  },
  {
    id: 3,
    title: 'Employment Rights and Workplace Protection',
    type: 'Article',
    readTime: '6 min read',
    category: 'Employment',
    summary: 'Know your rights regarding wages, discrimination, and wrongful termination.'
  },
  {
    id: 4,
    title: 'Contract Basics: What Makes an Agreement Binding',
    type: 'Guide',
    readTime: '10 min read',
    category: 'Contracts',
    summary: 'Understanding contract formation, breach, and remedies for agreement violations.'
  }
];

export const mockStats = {
  totalCases: 5420,
  successRate: 91,
  avgResolutionTime: '14 days',
  userSatisfaction: 4.8,
  documentTypes: 150,
  activeUsers: 800
};